import React, { useCallback } from 'react'

import {
  SubmitInvestmentEntitySelectionRequest,
  SubmitInvestmentEntitySelectionResponse,
} from '@cash-web/protos/squareup/cash/investflow/flows/actions.pb'
import { InvestmentEntitySelectionBlocker } from '@cash-web/protos/squareup/franklin/blockers/investment_entity_selection_blocker.pb'
import { createReactQueryMutationHook } from '@cash-web/shared-data-access-api/types'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'
import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'

import { BlockerProps } from '..'
import { InvestmentEntitySelection } from './InvestmentEntitySelection'

interface Props extends BlockerProps {
  blocker: InvestmentEntitySelectionBlocker
}

const submitInvestmentEntityToken = (request: SubmitInvestmentEntitySelectionRequest, options?: CashRequestOptions) =>
  post<SubmitInvestmentEntitySelectionRequest, SubmitInvestmentEntitySelectionResponse>(
    '/cash-app/investing/submit-investment-entity-token',
    request,
    { ...options, rejectOnError: true }
  )

const useMutationSubmitInvestmentEntityToken = createReactQueryMutationHook(
  'submitInvestmentEntityToken',
  submitInvestmentEntityToken
)

export function BlockerInvestmentEntitySelection({ blocker }: Props): React.ReactElement {
  const flow = useFlowContext()

  const { mutateAsync: submitInvestment } = useMutationSubmitInvestmentEntityToken({
    options: { flowToken: flow.active?.flowToken },
  })

  return (
    <InvestmentEntitySelection
      blocker={blocker}
      submitInvestment={useCallback(
        entity => {
          return submitInvestment({
            investment_entity_token: entity,
            request_context: { blocker_descriptor_id: 'SELECT_INVESTMENT_ENTITY' },
          })
        },
        [submitInvestment]
      )}
      submitMultipleInvestments={useCallback(
        entities => {
          return submitInvestment({
            selection: { investment_entity_tokens: [...entities] },
            request_context: { blocker_descriptor_id: 'SELECT_INVESTMENT_ENTITY' },
          })
        },
        [submitInvestment]
      )}
    />
  )
}
